import { GridColDef } from "@mui/x-data-grid-pro";
import { AdminResponse } from "entities/auth/api/getAdmins";
import { AdminRole } from "entities/auth/types";
import DropdownList, {
  DropdownListItemProps,
} from "shared/components/DropdownList";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import { ModalHookResult } from "shared/hooks/useModalState";
import { COLOR_PRIMARY_MAIN } from "shared/theme/colors";
import { ArrowForwardIcon } from "shared/theme/icons/ArrowForwardIcon";
import RoleChips from "./components/RoleChips";

type RolesAndPermissionsColumnsProps = {
  adminDetailsDrawer: DrawerHookResult<string>;
  deleteAdminModal: ModalHookResult;
  resetPasswordModal: ModalHookResult;
  roles: AdminRole[];
  readOnly: boolean;
};

export const getRolesAndPermissionsColumns = ({
  adminDetailsDrawer,
  deleteAdminModal,
  resetPasswordModal,
  roles,
  readOnly,
}: RolesAndPermissionsColumnsProps): GridColDef[] => {
  const renderActions = (admin: AdminResponse) => {
    if (readOnly) {
      return (
        <FlexCenter onClick={() => adminDetailsDrawer.openDrawer(admin.id)}>
          <ArrowForwardIcon color={COLOR_PRIMARY_MAIN} />
        </FlexCenter>
      );
    }

    const isSuperAdmin = roles.includes(AdminRole.SuperAdmin);

    const items: DropdownListItemProps[] = [
      {
        title: "Edit",
        onClick: () => adminDetailsDrawer.openDrawer(admin.id),
      },
      ...(isSuperAdmin
        ? [
            {
              title: "Send Reset Password",
              onClick: () => resetPasswordModal.openModal(admin),
            },
          ]
        : []),
      {
        title: "Delete",
        style: "remove",
        onClick: () => deleteAdminModal.openModal(admin),
      },
    ];

    return <DropdownList items={items} />;
  };

  return [
    {
      field: "email",
      headerName: "Email address",
      editable: false,
      flex: 1,
      sortable: false,
    },
    {
      field: "roles",
      headerName: "Roles",
      editable: false,
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        return <RoleChips roles={params.value} />;
      },
    },
    {
      field: "actions",
      headerName: "",
      editable: false,
      sortable: false,
      align: "right",
      headerAlign: "right",
      renderCell: (params) => renderActions(params.row),
    },
  ];
};
